import React from "react";
import { Divider, Container, Header, Image } from "semantic-ui-react";
const imageList = [
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/configapp%2F4.png?alt=media&token=0b0ce502-933e-4627-981e-8fa6f18fa01a",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/configapp%2F3.png?alt=media&token=9b7445eb-c438-450c-8879-b69e7e88d424",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/configapp%2F2.png?alt=media&token=631ef85a-aecb-473d-8dcf-cabe55250660",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/configapp%2F1.png?alt=media&token=aac2c451-646c-4341-9d89-7308fd3f197f"
];
export const config_app = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Config app</Header.Content>
        <Header.Subheader>
          <p>
            It's an admin portal to setup the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://plp.zaya.in/classcloud/"
              title="Checkout our cool classcloud"
            >
              Classcloud
            </a>{" "}
            for the first time, so that user has a plug n play experience. Few
            screen shots given below
          </p>
          <p>
            Credit : Designed and co-developed with{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/ankitkulkarni/"
            >
              @Ankit
            </a>
          </p>
        </Header.Subheader>
      </Header>
      <Divider />
      <Image.Group>
        {imageList.map((url, i) => {
          return <Image rounded src={url} key={i} />;
        })}
      </Image.Group>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/config_app.js